import { t } from '../logical/index.js';
import { createStatisticConfig } from './create.js';
import type { StatisticsConfig } from './types.js';

export const checkboxTypeStatsFunctions: StatisticsConfig[] = [
  createStatisticConfig({
    group: '计数',
    type: 'count-values',
    dataType: t.boolean.instance(),
  }),
  createStatisticConfig({
    group: '计数',
    type: 'count-unique-values',
    dataType: t.boolean.instance(),
  }),
  createStatisticConfig({
    group: '计数',
    type: 'count-empty',
    dataType: t.boolean.instance(),
    menuName: '统计未选中',
    displayName: '未选中',
    impl: data => {
      const emptyList = data.filter(value => !value);
      return emptyList.length.toString();
    },
  }),
  createStatisticConfig({
    group: '计数',
    type: 'count-not-empty',
    dataType: t.boolean.instance(),
    menuName: '统计已选中',
    displayName: '已选中',
    impl: data => {
      const notEmptyList = data.filter(value => !!value);
      return notEmptyList.length.toString();
    },
  }),
  createStatisticConfig({
    group: '百分比',
    type: 'percent-empty',
    dataType: t.boolean.instance(),
    menuName: '未选中百分比',
    displayName: '未选中',
    impl: data => {
      if (data.length === 0) return '';
      const emptyList = data.filter(value => !value);
      return ((emptyList.length / data.length) * 100).toFixed(2) + '%';
    },
  }),
  createStatisticConfig({
    group: '百分比',
    type: 'percent-not-empty',
    dataType: t.boolean.instance(),
    menuName: '已选中百分比',
    displayName: '已选中',
    impl: data => {
      if (data.length === 0) return '';
      const notEmptyList = data.filter(value => !!value);
      return ((notEmptyList.length / data.length) * 100).toFixed(2) + '%';
    },
  }),
];
